import React, { useState } from 'react';
import { ListItemText, ListItem } from '@mui/material';
import BaseFilterPopover from './BaseFilterPopover';
import EquipmentTypeSelector from '../selectors/EquipmentTypeSelector';

const EquipmentTypeFilterPopover = ({ label, onApplyFilter }) => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleOnApplyFilter = (value) => {
    onApplyFilter(value);
    setSelectedOption('');
  };

  return (
    <BaseFilterPopover label={label} value={selectedOption} onApplyFilter={handleOnApplyFilter}>
      <div style={{ padding: '16px', minWidth: '300px' }}>
        <EquipmentTypeSelector
          setValue={setSelectedOption}
          sortOptions={(t1, t2) => t1?.name > t2?.name}
          renderOptions={(props, option) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <ListItem {...props}>
              <ListItemText>{option.tagName}</ListItemText>
            </ListItem>
          )}
        />
      </div>
    </BaseFilterPopover>
  );
};

export default EquipmentTypeFilterPopover;
